import {
	FeatureIslandContainer,
	FeatureIslandHeader,
	FeatureIslandMainWithBackGround,
} from "@/components/features/_layouts";

import { useFetchContactList } from "../api";
import { ContactListEmptyState } from "./empty-state";
import { ContactTopPageHeaderRightChildren } from "./header-right-children";
import { ContactList as List } from "./list";

type Props = {
	hotelID: string;
};

export const ContactList = ({ hotelID }: Props) => {
	const { data } = useFetchContactList({ hotelID });
	// 問い合わせが存在しない場合
	const isEmpty = data?.contactList.contacts.length === 0;

	return (
		<FeatureIslandContainer>
			<FeatureIslandHeader
				title="問い合わせ"
				rightChildren={<ContactTopPageHeaderRightChildren hotelID={hotelID} />}
			/>
			<FeatureIslandMainWithBackGround islandTitle="過去の問い合わせ一覧">
				{isEmpty ? (
					<ContactListEmptyState hotelID={hotelID} />
				) : (
					<List hotelID={hotelID} contactList={data?.contactList.contacts ?? []} />
				)}
			</FeatureIslandMainWithBackGround>
		</FeatureIslandContainer>
	);
};

ContactList.displayName = "ContactList";
